import { Scanner } from "@yudiel/react-qr-scanner";

const QrScannerComponent = ({setQrCode, setQrError, setIsScanned}) => {

    const handleScan = (detectedCodes) => {
        detectedCodes.forEach(dc => {
            if (dc.format === "qr_code") {
                const code = dc.rawValue;

                if (code.includes("energiepool.at") && code.includes("qr/")) {
                    setQrCode(code.split('qr/')[1]);
                    setIsScanned(true);
                }
            }
        });
    }

    return (
        <div style={{display: "flex", alignItems: "center", justifyContent:"center"}}>
            <div style={{height: "40vh"}}>
                <Scanner
                    onScan={handleScan}
                    onError={(err) => setQrError(err?.message)}
                    constraints={{
                        facingMode: 'environment',
                    }}
                />
            </div>
        </div>
    )
}

export default QrScannerComponent;